import { Col, Typography } from 'antd';
import { FC } from 'react';
import { ControllerProps } from 'react-hook-form';

import { useProgramStepContext } from 'src/features/programsV2/contexts/ProgramStepContext';
import { VisualStepForm } from 'src/features/programsV2/schemas/visualStepSchema';
import { GenderOptions } from 'src/features/programsV2/types/program';

import { ProgramSection } from '../../ui/ProgramSection';
import { ProgramSectionGroup } from '../../ui/ProgramSectionGroup';
import { ImageUpload } from './ImageUpload';

interface ProgramThumbsProps {
  title: string;
  helperText: string;
  fieldName: ControllerProps<VisualStepForm>['name'];
  maxDimensions: {
    width: number;
    height: number;
  };
}

const { Text } = Typography;

export const ProgramThumbs: FC<ProgramThumbsProps> = ({
  title,
  helperText,
  fieldName,
  maxDimensions,
}) => {
  const generateFieldName = (name: string) =>
    `${fieldName}.${name}` as ControllerProps<VisualStepForm>['name'];

  const { getStepDefaultValues, programApiInitialValues } =
    useProgramStepContext();

  const selectedGender =
    getStepDefaultValues('configurationStep')?.gender ??
    programApiInitialValues?.configurationStep?.gender;

  return (
    <ProgramSection style={{ padding: '24px 16px' }}>
      <ProgramSectionGroup>
        <Text>{title}</Text>
      </ProgramSectionGroup>
      <ProgramSectionGroup gutter={24}>
        <Col span={8}>
          <ImageUpload
            title='Neutro'
            helperText={helperText}
            fieldName={generateFieldName('neutral')}
            disabled={!selectedGender?.includes(GenderOptions.Neutral)}
            maxDimensions={maxDimensions}
          />
        </Col>
        <Col span={8}>
          <ImageUpload
            title='Feminino'
            helperText={helperText}
            fieldName={generateFieldName('female')}
            disabled={!selectedGender?.includes(GenderOptions.Female)}
            maxDimensions={maxDimensions}
          />
        </Col>
        <Col span={8}>
          <ImageUpload
            title='Masculino'
            helperText={helperText}
            fieldName={generateFieldName('male')}
            disabled={!selectedGender?.includes(GenderOptions.Male)}
            maxDimensions={maxDimensions}
          />
        </Col>
      </ProgramSectionGroup>
    </ProgramSection>
  );
};
